// extracted by mini-css-extract-plugin
export var image = "ArticleHighlight-module--image--6oVVL";
export var label = "ArticleHighlight-module--label--1vtxC";
export var title = "ArticleHighlight-module--title--av+W6";
export var wrapper = "ArticleHighlight-module--wrapper--opu3-";